<template>
  <div>
    <div class="cms-news-list-header">
      <a href="/" class="cms-news-list-header__back-link">
        <svg-icon icon="straight-arrows/right" viewBox="0 0 16 16"/>
        <span>{{ $res.Views.News_BackToMainPage }}</span>
      </a>
      <div class="cms-news-list-header__title">
        {{ $res.Views.News_Header }}
      </div>
    </div>
    <div class="cms-news-list-wrapper" ref="listWrapper">
      <cms-news-search-form @search="onSearch"
                            @reset="onReset"
                            :query="query"
                            :filters="filters"
                            :has-promo-news="hasPromoNews"
                            :total-items-found="totalItemsFound"
                            :show-agency-news-tab="showAgencyNewsTab" />
      <cms-news-list v-if="!isLoading"
                     :items="items"
                     :paginator-current-page="currentPage"
                     :paginator-href-text-prefix="paginatorHrefTextPrefix"
                     :total-items-found="totalItemsFound"
                     :items-on-page="10"
                     @paginator-page-changed="onPaginatorPageChanged"/>
      <div v-else class="cms-news-list-wrapper__content--loading"></div>
    </div>
  </div>
</template>

<script>
import Base from "./CmsNewsListAppBase";
import CmsNewsSearchForm from "./components/CmsNewsSearchFormComponent.vue";
import CmsNewsList from "./components/CmsNewsListComponent.vue";
import SvgIcon from "@/common/controls/SvgIconControl.vue";

export default {
  extends: Base,
  components: {
    SvgIcon,
    CmsNewsSearchForm,
    CmsNewsList,
  },
}
</script>

<style lang="scss" scoped>
.cms-news-list-header {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cms-news-list-header__back-link {
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 13px;
  width: fit-content;
  
  svg {
    transform: rotate(180deg);
  }
}

.cms-news-list-header__title {
  font-size: 28px;
  line-height: 44px;
  font-weight: 600;
}

.cms-news-list-wrapper {
  display: flex;
  flex-flow: column;
  gap: 20px;
}

.cms-news-list-wrapper__content--loading {
  height: 100vh;
}
</style>
